import $ from "jquery";
import PageBase from "./PageBase";
import { MenuViewApp } from "../modules";


export default class MenuApp extends PageBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    const dispatcher = this.initTopImage();
    dispatcher.bind("init", () => {
      this.initFadeAnimation();
    });

    const menu = new MenuViewApp();
    menu.init();

    this.$contentList = $("#js-contents").find(".content");
    this.$contentList.hide();
    this.$tabButtonList = $("#js-tab").find(".tab__button");

    window.onhashchange = () => {
      this.handleHasnChange();
    };

    this.handleHasnChange();
    this.initHeaderColorChange();
  }

  handleHasnChange() {
    const hash = location.hash.length <= 0 ? null : location.hash;

    if (hash) {
      this.setContent(hash.replace("#", ""));
    } else {
      this.setContent("lunch");
    }
  }

  setContent(hash) {
    this.$contentList.hide();
    this.$tabButtonList.removeClass("selected");

    const $tab = $(`#js-tab-${hash}`);
    const $content = $(`#js-content-${hash}`);

    $tab.addClass("selected");
    $content.show();
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/MenuApp.js